module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "error-404"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'home'
        })
      }
    }
  }, [_c('h1', [_vm._v("404")]), _vm._v("\n\tClick screen or tap to go Home.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36067244","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/Error404.vue
// module id = 115
// module chunks = 1